/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsersKey: {
  name: 'users-key';
  data: string;
} = {
  name: 'users-key',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3.5 4a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Zm10-2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0ZM14 .5a1.5 1.5 0 0 0-1.354 2.147l-.5.5-.5.5a.5.5 0 0 0 .708.707l.146-.147.146.147a.5.5 0 0 0 .708-.708l-.147-.146.146-.146A1.5 1.5 0 1 0 14 .5ZM1.5 15a5.5 5.5 0 1 1 11 0 .5.5 0 0 0 1 0 6.5 6.5 0 1 0-13 0 .5.5 0 0 0 1 0Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
